<template>
<div class='policy'>
        <a v-on:click="back">
          <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
        </a>
        <div v-html="terms"></div>    
       <a class="button_full btyellow" v-on:click="back" :style="borderStyle">Back</a>      
    </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'terms-of-use',
  methods: {
    ...mapActions({
      getTerms: 'recommendFriend/getTerms'
    }),
    back () {
      this.$emit('goback')
    }
  },
  async created () {
    await this.getTerms()
  },
  computed: {
    ...mapState({
      customization: state => state.common.customization
    }),
    ...mapGetters({
      terms: 'recommendFriend/terms'
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// terms-of-use.vue?45b07fc7